#import '../../../../shared/graphql/fragments/lead-step-fragment.graphql'

mutation UnskipStepForLead($input: StepUnskipInput!) {
    stepUnskip(input: $input) {
        step {
            ...LeadStepFragment
        }
    }
}
